module.exports = __webpack_public_path__ + "img/ne_get.2e62b31.png";